import { React, useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';



import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Box,
  Flex,
  Text,
  Badge,
  VStack,
  HStack,
  Tag,
  Input,
  Avatar,
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  IconButton,
  Textarea,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Select,
} from '@chakra-ui/react';
import {
  FaLock,
  FaEye,
  FaShareAlt,
  FaUserCircle,
  FaEdit,
} from 'react-icons/fa';

import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';

import { Tooltip } from '@chakra-ui/react';
import UserAvatar from '../../../../components/userAvatar/index';

import {
  
  ChevronDownIcon,
} from '@chakra-ui/icons';
import { Spinner } from 'reactstrap';
// import SubTaskModal from './SubTaskModal';
import { useParams } from 'react-router-dom';

import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';

const Timelinesubtasktable = ({ assigneeList,
  statusList,
  taskdata,
  taskDetails,
  reload,
  openSubtaskModal
  }) => {
   
     const { id: projectId } = useParams();
    
      const [childTasks, setChildTasks] = useState([]);
      const [editableTasks, setEditableTasks] = useState({});
      const [loadingSubtasks, setLoadingSubtasks] = useState(false);
   
    
      
      const roleId = Number(Cookies.get('task-role-id'));
      
       
    
      useEffect(() => {
        getsubtaskList();
       
      }, [taskdata, reload]);
      
    
      
    
      const getsubtaskList = async () => {
        setLoadingSubtasks(true);
        let reqbody = {
          project_id: taskDetails?.project_id ? taskdata?.project_id : projectId,
          task_id: taskdata?.task_id,
        };
     
    
        try {
          const response = await httpInjectorService.getsubtaskList(reqbody);
          setChildTasks(response.data);
          // assuming array of { id, title }
        } catch (error) {
          console.error('Error fetching subtasks:', error);
        } finally {
          setLoadingSubtasks(false);
        }
      };
    
      const handleEditChange = (subtaskId, field, value) => {
        setEditableTasks((prev) => ({
          ...prev,
          [subtaskId]: {
            ...prev[subtaskId],
            [field]: value,
          },
        }));
      };
    
      const saveSubtask = async (subtaskId) => {
        const edited = editableTasks[subtaskId] || {};
        const original = childTasks.find((t) => t.subtask_id === subtaskId);
    
        if (!original) {
       
          return;
        }
    
        const reqBody = {
          project_id: taskdata?.project_id ? taskdata.project_id : projectId, // or dynamic
          subtask_id: subtaskId,
          title: edited.title !== undefined ? edited.title : original.subtask_title,
          subtask_status:
            edited.status !== undefined ? edited.status : original.status,
          subtask_priority:
            edited.priority !== undefined
              ? edited.priority
              : original.priority || 'Medium',
          subtask_assignee_id:
            edited.assignee_id !== undefined
              ? edited.assignee_id
              : original.assignee_id || null,
        };
    
        try {
          const response = await httpInjectorService.updateSubtask(reqBody);
          if (response.status === 'success') {
            // Optionally refresh or give feedback
          }
        } catch (error) {
         throw error
        }
      };
    
      const deleteChildTask = async (subtaskId) => {
        try {
          let reqbody = {
            project_id: taskdata.project_id ,
            subtask_ids: [subtaskId],
          };
          let response = await httpInjectorService.delete_subtask(reqbody);
          if (response.status === 'success') {
            toast.success(response.message, {
              position: 'top-right',
              autoClose: 3000,
            });
            setChildTasks((prev) =>
              prev.filter((task) => task.subtask_id !== subtaskId),
            );
          } else {
            toast.error(response.message, {
              position: 'top-right',
              autoClose: 3000,
            });
          }
        } catch (error) {
         throw error
        }
      };
  return (
      <div>
          {' '}
          {childTasks?.length > 0 && [1, 2, 3].includes(roleId) && (
            <Box mt={6}>
              <Text fontWeight="semibold" mb={2}>
                SubTasks
              </Text>
    
              <Box
                borderWidth="1px"
                borderRadius="md"
                overflow="hidden"
                boxShadow="sm"
              >
                <Box maxH="300px" overflowY="auto">
                  <Table size="sm" border="1px solid #E2E8F0">
                    <Thead bg="gray.100" position="sticky" top={0} zIndex={0}>
                      <Tr>
                        <Th borderRight="1px solid #E2E8F0"></Th>
                        <Th borderRight="1px solid #E2E8F0" w="300px">
                          Work
                        </Th>
                        <Th borderRight="1px solid #E2E8F0">Priority</Th>
                        <Th borderRight="1px solid #E2E8F0">Assignee</Th>
                        <Th>Status</Th>
                      </Tr>
                    </Thead>
    
                   <Tbody>
      {childTasks?.map((task) => {
        const edited = editableTasks[task.subtask_id] || {};
    
        const assigneeIdToUse =
          edited.assignee_id !== undefined ? edited.assignee_id : task.assignee_id;
    
        const assigneeObj = assigneeList?.find(
          (a) => a.user_id === assigneeIdToUse
        );
    
        const subtaskTitle =
          edited.title !== undefined ? edited.title : task?.subtask_title;
    
        const selectedStatus = edited.status || task.status || 'TO DO';
    
        const handleSave = () => saveSubtask(task.subtask_id);
    
        return (
          <Tr key={task.subtask_id}>
            <Td>
              <Box
                as="button"
                style={{
                  color: '#3182ce',
                  fontWeight: '500',
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                }}
                 onClick={() => openSubtaskModal(task)}
              >
                {task.subtask_key}
              </Box>
            </Td>
    
            {/* Editable title */}
            <Td borderRight="1px solid #E2E8F0" w="300px">
              <Tooltip label={subtaskTitle} hasArrow placement="top" openDelay={300}>
                <Input
                  size="sm"
                  value={subtaskTitle}
                  onChange={(e) =>
                    handleEditChange(task.subtask_id, 'title', e.target.value)
                  }
                  onKeyDown={(e) => e.key === 'Enter' && handleSave()}
                  onBlur={handleSave}
                />
              </Tooltip>
            </Td>
    
            {/* Priority */}
            <Td borderRight="1px solid #E2E8F0">
              <Menu>
                <MenuButton
                  as={Button}
                  size="xs"
                  variant="outline"
                  colorScheme="gray"
                  rightIcon={<ChevronDownIcon />}
                >
                  {edited.priority || task.priority || 'Medium'}
                </MenuButton>
                <MenuList>
                  {['Low', 'Medium', 'High'].map((priority) => (
                    <MenuItem
                      key={priority}
                      onClick={() => {
                        handleEditChange(task.subtask_id, 'priority', priority);
                        handleSave();
                      }}
                    >
                      {priority}
                    </MenuItem>
                  ))}
                </MenuList>
              </Menu>
            </Td>
    
            {/* Assignee */}
            <Td borderRight="1px solid #E2E8F0">
              <Menu isLazy>
                <Tooltip
                  label={assigneeObj ? assigneeObj.username : 'Unassigned'}
                  hasArrow
                  placement="top"
                  openDelay={300}
                >
                  <MenuButton
                    as={Button}
                    variant="ghost"
                    size="sm"
                    rightIcon={<ChevronDownIcon />}
                  >
    
                    <Box>
                      <UserAvatar
                        username={assigneeObj ? assigneeObj.username : 'Unassigned'}
                        size={24}
                      />
                    </Box>
                  </MenuButton>
                </Tooltip>
    
                <MenuList maxH="200px" overflowY="auto" zIndex={1500}>
                  {assigneeList?.map((assignee) => (
                    <MenuItem
                      key={assignee.user_id}
                      onClick={() => {
                        handleEditChange(task.subtask_id, 'assignee_id', assignee.user_id);
                        handleSave();
                      }}
                    >
                      <Tooltip label={assignee.username} hasArrow placement="right" openDelay={300}>
                        <Flex align="center" gap="2">
                          <UserAvatar username={assignee.username} size={24} />
                          <Text fontSize="sm">{assignee.username}</Text>
                        </Flex>
                      </Tooltip>
                    </MenuItem>
                  ))}
                </MenuList>
              </Menu>
            </Td>
    
            {/* Status */}
            <Td>
              <Menu>
                <MenuButton
                  as={Button}
                  size="xs"
                  variant="outline"
                  colorScheme="gray"
                  rightIcon={<ChevronDownIcon />}
                >
                  {selectedStatus}
                </MenuButton>
                <MenuList>
                  {statusList?.map((status) => (
                    <MenuItem
                      key={status.status_name}
                      onClick={() => {
                        handleEditChange(task.subtask_id, 'status', status.status_name);
                        handleSave();
                      }}
                    >
                      {status.status_name}
                    </MenuItem>
                  ))}
                </MenuList>
              </Menu>
            </Td>
          </Tr>
        );
      })}
    </Tbody>
    
                  </Table>
                </Box>
              </Box>
            </Box>
          )}
         
         
    
        </div>
  )
}

export default Timelinesubtasktable